import { render, staticRenderFns } from "./RewokrsModulesRootView.vue?vue&type=template&id=25b51f10"
import script from "./RewokrsModulesRootView.vue?vue&type=script&lang=js"
export * from "./RewokrsModulesRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports